import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import ToggleSwitch from "components/ToggleSwitch/ToggleSwitch";

// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

function Notifications() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [switches, setSwitches] = useState({
    switch1: false,
    switch2: false,
    switch3: false,
  });

  const toggleSwitch = (switchName) => {
    setSwitches((prevSwitches) => ({
      ...prevSwitches,
      [switchName]: !prevSwitches[switchName],
    }));
  };

  useEffect(() => {
    retrieveNotififcation();
  }, []);

  const retrieveNotififcation = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setTransaction(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short" }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <>
      <div className="content jag-web">
        <div className="auto-adjust">
          <Col lg="8" md="8" sm="6" className="house-all">
            <div className="typography-line-dash  line-dash-mob welcome-msg ">
              <h2>Notifications</h2>
              <p>
                Receive notification on product updates ,newsletter ,account
                statement and balance
              </p>
            </div>
          </Col>
          <Col lg="8" md="8" sm="6" className="house-all">
            <div className="mob-width">
              <div className="noti-line no-noti-line">
                {" "}
                <p>General Notifications</p>
                <ToggleSwitch
                  isOn={switches.switch1}
                  toggleSwitch={() => toggleSwitch("switch1")}
                />
              </div>
              <div className="noti-line no-noti-line">
                {" "}
                <p>Transaction Notifications</p>
                <ToggleSwitch
                  isOn={switches.switch2}
                  toggleSwitch={() => toggleSwitch("switch2")}
                />
              </div>
              <div className="noti-line no-noti-line">
                {" "}
                <p>Product Update</p>
                <ToggleSwitch
                  isOn={switches.switch3}
                  toggleSwitch={() => toggleSwitch("switch3")}
                />
              </div>
              <div className="noti-line no-noti-line">
                {" "}
                <p>Email Notifications</p>
                <ToggleSwitch
                  isOn={switches.switch4}
                  toggleSwitch={() => toggleSwitch("switch4")}
                />
              </div>
              
            </div>
          </Col>
          <Row>
          <Col md="5">
            <Card className="outer-line noti-card">
              <CardTitle tag="h5"> Recent Notifications</CardTitle>
              <CardBody className="jag-tran-card" style={{ color: "#667085" }}>
                {transaction.map((transaction) => (
                  <div key={transaction.id} className="jag-transaction-item">
                    <div className="jag-transaction-info">
                      <div>
                        <div
                          className="jag-transaction-type"
                          style={{ textTransform: "uppercase" }}
                        >
                          {transaction.title}
                        </div>

                        <div className="jag-transaction-type noti-mess">
                          {transaction.message}
                        </div>
                      </div>
                    </div>
                    <div className="jag-transaction-details">
                      <div
                        className="jag-transaction-time"
                        style={{ paddingLeft: "1px" }}
                      >
                        {formatDate(transaction.createdAt)}
                      </div>
                    </div>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
        </div>
      </div>
     
        
      
      
      
    </>
  );
}

export default Notifications;
